<template>
    <div class="flex w-full">
        <WikiContainer/>
    </div>
</template>

<script>
    import WikiContainer from '@modules/wiki/WikiContainer.vue';
    import i18n from '@app/localization/i18n';
    import { showHelp, hideHelp } from '@src/app/modules/help';

    const helpPage = i18n.t('help-url');

    function handleChat(route) {
        if (route.params.pageSlug === helpPage) {
            showHelp();
        } else {
            hideHelp();
        }
    }

    export default {
        name: 'WikiPage',
        /*
        These handlers are here rather than in router/index.ts because:
            - we tend to avoid using window in .ts files
            - the chat is related only to the UI and is thus kept in a UI related file
            - the performed operations are very specific and not reusable
        */
        beforeRouteEnter(to, from, next) {
            handleChat(to);
            next();
        },
        beforeRouteLeave(to, from, next) {
            hideHelp();
            next();
        },
        beforeRouteUpdate(to, from, next) {
            handleChat(to);
            next();
        },
        components: {
            WikiContainer,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/pages/WikiPage.vue